import { render } from "./CourseMaintain.vue?vue&type=template&id=45f4c81c"
import script from "./CourseMaintain.vue?vue&type=script&lang=ts"
export * from "./CourseMaintain.vue?vue&type=script&lang=ts"
script.render = render

export default script